<template>
  <div v-html="content" style="text-align: left;" />
</template>

<script>
import axios from 'axios'
import config from '@/config'

export default {
  name: 'text-only',
  version: '0.0.1',
  props: {
    contentKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      content: '... loading content!'
    }
  }, // data
  async mounted () {
    try {
      const resp = await axios.get(config.glapiBaseUri + '/content/byContentKey/' +
        this.contentKey + '/toHtml')
      this.content = resp.data
      console.log('TRACE-REMOVE: TextOnly: resp is: ', resp)
    } catch (e) {
      this.content = 'Error loading the content!'
      console.error('ERROR: Exception is: ', e)
    }
  }
}
</script>

<style scoped>
</style>
